import DefaultTeamsFeatureList from './features/defaultTeamsFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';

export default summaryFeaturesTransformer(DefaultTeamsFeatureList, {
  ...FeatureRules,
  // Add feature rule overrides below
});
